import { useEffect, useState } from "react";
import Header from "./Header";
import Right from "./Right";
import { server } from "../../server";
import { getUserIdFromToken } from "../../utils/auth";
import { Link, useNavigate } from "react-router-dom";

function Payment() {
  const navigate = useNavigate();
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPaymentHistoryWithMemberships = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const userId = getUserIdFromToken();

        const response = await fetch(
          `${server}/PaymentHistory?userId=${userId}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );

        const data = await response.json();
        const payments = data?.payments || [];

        const paymentsWithMemberships = await Promise.all(
          payments.map(async (payment) => {
            try {
              const membershipRes = await fetch(
                `${server}/membership/GetMembershipById?id=${payment.membershipId}`,
                {
                  headers: {
                    Authorization: token,
                  },
                }
              );
              const membershipData = await membershipRes.json();

              return {
                ...payment,
                membership: membershipData,
              };
            } catch (err) {
              console.error("Membership fetch failed:", err);
              return { ...payment, membership: null };
            }
          })
        );

        setPaymentHistory(paymentsWithMemberships);
      } catch (err) {
        console.error("Payment history fetch failed:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentHistoryWithMemberships();
  }, []);

  return (
    <>
      <Header />

      <section>
        <div className="container pt-3">
          <div className="row g-3">
            <div className="col-lg-8 col-12 mb-5">
              <div className="d-flex align-items-center mb-3">
                <Link
                  onClick={() => navigate(-1)}
                  className="icon-shape me-3 icon-lg bg-light-red rounded-circle"
                >
                  <i className="bi bi-chevron-left fs-3 text-primary"></i>
                </Link>
                <div>
                  <h3 className="fw-medium ls-sm text-dark lh-1 fs-4 m-0">
                    Payment History
                  </h3>
                  <p className="lh-sm fw-normal m-0">
                    Membership payment history of your account.
                  </p>
                </div>
              </div>

              {loading ? (
                <div className="text-center my-5">
                  <div className="spinner-border text-red-primary"></div>
                </div>
              ) : paymentHistory.length === 0 ? (
                <p className="text-center text-muted">
                  No payment history found.
                </p>
              ) : (
                <div className="row g-2">
                  {paymentHistory.map((item, index) => (
                    <div className="col-lg-6 col-12" key={index}>
                      <div className="card rounded-4 border-danger position-relative h-100">
                        <div className="card-body">
                          <h4 className="text-uppercase mb-0 lh-sm fw-semibold">
                            {item?.membership?.plan}
                          </h4>

                          <p className="text-danger mb-2 lh-sm">
                            {item?.membership?.durationTitle}
                          </p>

                          <p className="text-muted mb-0 lh-sm">
                            {item?.membership?.planDescription}
                          </p>

                          <h4 className="my-2">
                            {item?.currency} {item?.amount}{" "}
                            <span className="text-success fs-6 ms-1 text-capitalize">
                              {item?.status}
                            </span>
                          </h4>

                          <p className="text-muted m-0 lh-1">
                            Order ID : {item?.razorpay_order_id}
                          </p>

                          <p className="text-muted m-0 lh-1">
                            Payment ID : {item?.razorpay_payment_id}
                          </p>

                          <p className="text-dark text-uppercase mt-3">
                            {new Date(item?.paidAt).toLocaleString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })}
                          </p>

                          <img
                            src="/assets/images/verify.png"
                            width="30"
                            className="position-absolute"
                            style={{
                              bottom: "20px",
                              right: "15px",
                            }}
                          ></img>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <Right />
          </div>
        </div>
      </section>
    </>
  );
}

export default Payment;
